import React, { useState } from "react";
import { CheckIcon, Plus, X, XIcon } from "lucide-react";

function ApplicationTags({
  applicationId,
  tags = [],
  availableTags = [],
  onAddTag,
  onRemoveTag,
}) {
  const [isAddingTag, setIsAddingTag] = useState(false);
  const [newTag, setNewTag] = useState("");
  const [isInputFocused, setIsInputFocused] = useState(false);

  const handleAddTag = () => {
    if (applicationId && newTag.trim()) {
      onAddTag(applicationId, newTag);
      CloseTagInput();
    }
  };
  const CloseTagInput = () => {
    setNewTag(""); // clear input
    setIsAddingTag(false); // close input
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2 flex-wrap">
        {tags.map((tag, index) => (
          <div
            key={index}
            className="bg-primary-dark text-white px-3 py-1 border border-input rounded-full flex items-center gap-1 text-sm"
          >
            {tag}
            <button
              onClick={() => onRemoveTag(index)}
              className="ml-1 text-foreground hover:scale-110"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}

        {isAddingTag ? (
          <div className="flex items-center gap-2 border border-input px-3 py-1 rounded-full w-full relative">
            <input
              type="text"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
              placeholder="Add tags..."
              onFocus={() => setIsInputFocused(true)}
              onBlur={() => setTimeout(() => setIsInputFocused(false), 400)}
              className="bg-transparent outline-none text-foreground text-sm placeholder-white/70 w-3/4"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleAddTag();
                }
              }}
            />
            <button
              onClick={handleAddTag}
              className="bg-card text-green-900 text-xs rounded-full hover:bg-green-50"
            >
              <CheckIcon className="p-1" />
            </button>
            <button
              onClick={CloseTagInput}
              className="bg-card text-red-600 text-xs rounded-full hover:bg-red-50"
            >
              <XIcon className="p-1" />
            </button>
            {/* Suggestions dropdown */}
            {isInputFocused && newTag.trim() && (
              <div className="absolute top-full left-0 mt-1 w-[265px] bg-card rounded-lg shadow-lg max-h-48 overflow-y-auto z-50">
                {availableTags
                  .filter((tag) =>
                    tag.toLowerCase().includes(newTag.toLowerCase()),
                  )
                  .map((tag, index) => (
                    <div
                      key={index}
                      className="px-4 py-2 hover:bg-muted cursor-pointer text-foreground text-sm"
                      onClick={() => {
                        setNewTag(tag);
                      }}
                    >
                      {tag}
                    </div>
                  ))}
              </div>
            )}
          </div>
        ) : (
          <button
            onClick={() => setIsAddingTag(true)}
            className="bg-primary-dark text-white px-3 py-1 rounded-full text-sm flex items-center gap-1 w-fit hover:scale-105"
          >
            <Plus className="w-3 h-3" /> Add Tag
          </button>
        )}
      </div>
    </div>
  );
}

export default ApplicationTags;
